export const SINGLE_MARKET_EXECUTIVE_REQUEST = "SINGLE_MARKET_EXECUTIVE_REQUEST";
export const SINGLE_MARKET_EXECUTIVE_SUCCESS = "SINGLE_MARKET_EXECUTIVE_SUCCESS";
export const SINGLE_MARKET_EXECUTIVE_FAILED = "SINGLE_MARKET_EXECUTIVE_FAILED";
export const SINGLE_MARKET_EXECUTIVE_RESET = "SINGLE_MARKET_EXECUTIVE_RESET";

